var toggle_des = document.querySelector('.collection_main_description .rich-text__content .rich-text__buttons a');
  toggle_des.addEventListener('click', function(e) {
  e.preventDefault();
  var dis_parent = this.closest('.rich-text__content');
  dis_parent.classList.toggle('open');
  if (dis_parent.classList.contains('open')) {
    this.innerText = 'Lees minder';
  } else {
    this.innerText = 'Lees meer';
  }
});